import { render } from "./TangkiPengagihan.vue?vue&type=template&id=d04b919a"
import script from "./TangkiPengagihan.vue?vue&type=script&lang=js"
export * from "./TangkiPengagihan.vue?vue&type=script&lang=js"

import "./TangkiPengagihan.vue?vue&type=style&index=0&id=d04b919a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__